export const WalletStatus = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  ERROR: 'error',
} as const;

export const EVM_WALLETS = {
  METAMASK: 'Metamask',
  COINBASE: 'Coinbase',
  WALLET_CONNECT: 'Wallet Connect',
} as const;
